<!-- VIP -->
<template>
  <div class="vip">
    <div class="header">
      <div class="wrapper">
        <div class="info">
          <div class="avatar-box">
            <img class="avatar" :src="avatarUrl" :onerror="defaultAvartarUrl">
            <img class="avatar-icon notvip" src="@/assets/global/notvip-icon.png" alt="" v-if="!isVip">
            <img class="avatar-icon vipicon" src="@/assets/global/vip-icon.png" alt="" v-if="isVip">
          </div>
          <div class="detail">
            <div class="user" @click="goLogin">
              <div class="nickname">{{ nickname || '未登录'}}</div>
              <div class="uid">{{ userId ? 'ID:' + userId : '登录后同步会员权益' }}</div>
            </div>
          </div>
        </div>
        <div class="card">
          <img class="card-icon" src="@/assets/vip/icon-vip-header.png">
          <div class="tip">
            <span>{{ tipText }}</span>
            <span class="tip-sub" v-show="isVip && isSub" @click="goSubPage">管理订阅</span>
          </div>
          <div class="btn-buy" @click="goBuyVip">{{ cardBtnText }}<img class="btn-buy-icon" src="@/assets/vip/icon-in.png"></div>
        </div>
      </div>
    </div>

    <div class="wrap rights">
      <h1 class="title">会员权益</h1>
      <swiper :options="swiperOption" class="list">
        <swiper-slide class="item">
          <img src="@/assets/vip/right-1.png" alt class="pic" />
        </swiper-slide>
        <swiper-slide class="item">
          <img src="@/assets/vip/right-2.png" alt class="pic" />
        </swiper-slide>
        <swiper-slide class="item">
          <img src="@/assets/vip/right-3.png" alt class="pic" />
        </swiper-slide>
        <swiper-slide class="item">
          <img src="@/assets/vip/right-4.png" alt class="pic" />
        </swiper-slide>
        <swiper-slide class="item">
          <img src="@/assets/vip/right-5.png" alt class="pic" />
        </swiper-slide>
        <swiper-slide class="item">
          <img src="@/assets/vip/right-6.png" alt class="pic" />
        </swiper-slide>
        <swiper-slide class="item">
          <img src="@/assets/vip/right-7.png" alt class="pic" />
        </swiper-slide>
        <swiper-slide class="item">
          <img src="@/assets/vip/right-8.png" alt class="pic" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="wrap layouts">
      <div class="layout" v-for="layout in layouts" :key="layout.title">
        <h1 class="layout-title">{{ layout.title }}<div class="layout-more" @click="goTopic(layout.topicId)">更多</div></h1>
        <div class="list">
          <template v-for="item in layout.list">
            <div class="item style2" @click="goAudioDetail(item.audio_id)" v-if="item.style == 2" :key="item.audio_id">
              <div class="cover-box">
                <img :src="item.audio_icon" alt="" class="cover">
                <img src="@/assets/vip/icon-vip.png" alt="" class="cover-tag">
              </div>
              <div class="info">
                <div class="name">{{ item.audio_name }}<span class="vip-free-tag">会员免费</span></div>
                <div class="desc">{{ item.audio_intro }}<span class="price-tag" v-show="item.good_price">{{ item.good_price }}元</span></div>
              </div>
            </div>
            <div class="item style1" @click="goAudioDetail(item.audio_id)" v-if="item.style == 1" :key="item.audio_id">
              <div class="cover-box">
                <img :src="item.audio_icon" alt="" class="cover">
                <img src="@/assets/vip/icon-vip.png" alt="" class="cover-tag">
              </div>
              <div class="info">
                <div class="name">{{ item.audio_name }}</div>
                <div class="desc">{{ item.audio_intro }}</div>
                <div class="tags">
                  <span class="price-tag" v-show="item.good_price">{{ item.good_price }}元</span>
                  <span class="vip-free-tag">会员免费</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="wrap more-rights">
      <h1 class="title">会员权益<div class="all-rights" @click="goMoreRights">全部权益<img src="@/assets/global/arrow_right.png" alt="" class="icon-more"></div></h1>
      <div class="list">
        <div class="item">
          <img src="@/assets/vip/right-more-1.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">会员故事畅听</h2>
            <p class="desc">VIP会员畅听，7000部、10万集有声作品。在有效期内可畅听：包含经典童话故事、大奖绘本、各类儿童故事、英语磨耳、英语知识、科普知识、必读名著、历史国学知识等。不仅听故事，还能学知识！</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-2.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">每月重磅作品</h2>
            <p class="desc">月均上新20部作品，知名IP不断引入，可听的内容不断扩充；每周精选VIP专题，不再选择焦虑。</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-8.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">不定期福利</h2>
            <p class="desc">关注公众号“口袋故事福利社”，回复“充电”，即可获得价值495元的学习充电大礼包。内容包含古诗词、英语课、名著故事和父母课堂等内容。</p>
          </div>
        </div>
      </div>
    </div>

    <div class="vip-help">
      <div class="item" @click="goUserHelp">会员常见问题<img src="@/assets/global/arrow_right.png" alt="" class="help-more-icon"></div>
    </div>

    <div class="buyvip" v-if="showBuyBtn" @click="goBuyVip">
      <div class="buyvip-text"><div class="buyvip-title">口袋故事会员</div><div class="buyvip-desc">畅听7000部精品故事</div></div>
      <div class="btn-buyvip"><img src="@/assets/vip/buy-icon.png" alt="" class="buyvip-icon">{{ buyBtnText }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { vipExpireFormatter } from '@/filters/index'
// import 'swiper/swiper-bundle.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import config from '@/config/config'
import { checkGoodPrice } from '@/apiv4/goods'
import { login } from '@/utils/login'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data () {
    return {
      vipTextDp: '',
      vipExpireDate: '',
      defaultAvartarUrl: 'this.src="' + require('../../assets/global/avatar.png') + '"',
      swiperOption: {
        allowTouchMove: true,
        slidesPerView: 'auto',
        slidesOffsetAfter: 20,
        freeMode: true
      },
      showBuyBtn: false,
      tipText: '',
      buyBtnText: '',
      cardBtnText: '',
      layouts: [
        {
          title: '本月热播榜单',
          topicId: '660',
          list: [
            {
              'audio_id': '11640',
              'audio_name': '海底小纵队',
              'audio_intro': 'BBC热播儿童海洋探险动画',
              'audio_icon': 'pic-hdxzd.jpg',
              'good_price': '4990',
              'style': 2,
              'position': 'local'
            },
            {
              'audio_id': '12078',
              'audio_name': '米小圈快乐成语',
              'audio_intro': '趣学200条必背成语',
              'audio_icon': 'b/8/brveuuj4.jpg',
              'good_price': '6900',
              'style': 1,
            },
            {
              'audio_id': '12024',
              'audio_name': '洪涛叔叔讲唐诗故事',
              'audio_intro': '回到诗中境，领略唐诗美 ',
              'audio_icon': 'b/4/h2hj1lbd.jpg',
              'good_price': '1900',
              'style': 1,
            },
            {
              'audio_id': '11492',
              'audio_name': '阿凡提的故事',
              'audio_intro': '用幽默与智慧 捍卫正义',
              'audio_icon': 'b/2/ap95b02.jpg',
              'good_price': '3400',
              'style': 1,
            },
            {
              'audio_id': '11320',
              'audio_name': '少年岳飞',
              'audio_intro': '马蹄声声，铁骨铮铮',
              'audio_icon': 'b/0/e9u9uyi5.jpg',
              'good_price': '4900',
              'style': 1,
            }
          ],
        },
        {
          title: '学古诗  轻松理解轻松背',
          topicId: '1205',
          list: [
            {
              'audio_id': '12197',
              'audio_name': '小米多诗词王国漫游记',
              'audio_intro': '跟李白杜甫交朋友',
              'audio_icon': 'b/7/d7bhmo38.jpg',
              'good_price': '4990',
              'style': 1,
            },
            {
              'audio_id': '11958',
              'audio_name': '光年诗词大冒险',
              'audio_intro': '每天一刻钟，轻松背古诗',
              'audio_icon': 'b/8/xf7h059v.jpg',
              'good_price': '6900',
              'style': 1,
            },
            {
              'audio_id': '11969',
              'audio_name': '米小圈快来学古诗',
              'audio_intro': '语文提分|新课标必背77首',
              'audio_icon': 'b/9/15x6e754.jpg',
              'good_price': '2900',
              'style': 1,
            },
            {
              'audio_id': '12364',
              'audio_name': '婷婷唱古文',
              'audio_intro': '幼儿园小学背诗神器',
              'audio_icon': 'b/4/4n4xa9kf.jpg',
              'good_price': '1990',
              'style': 1,
            }
          ],
        },
        {
          title: '学作文  好词句信手拈来',
          topicId: '141',
          list: [
            {
              'audio_id': '12338',
              'audio_name': '大语文中国故事',
              'audio_intro': '每天语文8分钟',
              'audio_icon': 'b/8/nbglbapl.jpg',
              'good_price': '1990',
              'style': 1,
            },
            {
              'audio_id': '11769',
              'audio_name': '作文王国奇遇记',
              'audio_intro': '迪士尼签约作家教作文',
              'audio_icon': 'b/9/cp6zjtm0.jpg',
              'good_price': '1990',
              'style': 1,
            },
            {
              'audio_id': '8841',
              'audio_name': '朱天衣的作文课',
              'audio_intro': '台湾名师教你写作文',
              'audio_icon': 'b/1/jl9t7kzx.jpg',
              // 'good_price': '799',
              'good_price': '',
              'style': 1,
            },
            {
              'audio_id': '10924',
              'audio_name': '米小圈写作小秘笈',
              'audio_intro': '给小学生的作文技巧',
              'audio_icon': 'b/4/9bf7v5xi.jpg',
              // 'good_price': '999',
              'good_price': '',
              'style': 1,
            }
          ]
        },
        {
          title: '学英语  快人一步提前学',
          topicId: '929',
          list: [
            {
              'audio_id': '12036',
              'audio_name': '豆包麻麻语法课',
              'audio_intro': '每天5分钟学英语语法',
              'audio_icon': 'b/6/qsk1q0ee.jpg',
              'good_price': '3699',
              'style': 1,
            },
            {
              'audio_id': '11798',
              'audio_name': '英语方法启蒙课',
              'audio_intro': '每天5分钟英语启蒙讲座',
              'audio_icon': 'b/8/bs5ben2l.jpg',
              'good_price': '3990',
              'style': 1,
            },
            {
              'audio_id': '11667',
              'audio_name': '100天突破英语单词',
              'audio_intro': '英语单词口诀课',
              'audio_icon': 'b/7/f671kkyr.jpg',
              'good_price': '4990',
              'style': 1,
            },
            {
              'audio_id': '11562',
              'audio_name': '蓝精灵之探寻神秘村',
              'audio_intro': '纯正发音 双语故事',
              'audio_icon': 'b/2/mtmkpcov.jpg',
              'good_price': '2990',
              'style': 1,
            }
          ]
        },
        {
          title: '学国学  腹有诗书气自华',
          topicId: '886',
          list: [
            {
              'audio_id': '10418',
              'audio_name': '浩然爸爸讲三国演义',
              'audio_intro': '读四大名著，从三国起步',
              'audio_icon': '/b/8/hzqc61iy.jpg',
              'good_price': '2990',
              'style': 1,
            },
            {
              'audio_id': '12063',
              'audio_name': '林汉达成语故事',
              'audio_intro': '追溯成语历史之源',
              'audio_icon': 'b/3/e080plek.jpg',
              'good_price': '3990',
              'style': 1,
            },
            {
              'audio_id': '12083',
              'audio_name': '魔力三字经',
              'audio_intro': '熟读三字经，知晓千古事',
              'audio_icon': 'b/3/6z5vde7f.png',
              'good_price': '3600',
              'style': 1,
            },
            {
              'audio_id': '10242',
              'audio_name': '中华历史人物故事',
              'audio_intro': '大禹治水的传说',
              'audio_icon': 'b/2/eh6mfafq.jpg',
              'good_price': '4900',
              'style': 1,
            }
          ]
        },
        {
          title: '学科学  激发小小探索欲',
          topicId: '887',
          list: [
            {
              'audio_id': '12232',
              'audio_name': '科学奇遇记-恐龙星球',
              'audio_intro': '恐龙星球大作战',
              'audio_icon': 'b/2/uvbl6r03.jpg',
              'good_price': '8900',
              'style': 1,
            },
            {
              'audio_id': '12220',
              'audio_name': '十万个为什么之人体真有趣',
              'audio_intro': '生病为什么会发烧',
              'audio_icon': 'b/0/sp0hjtwl.jpg',
              'good_price': '2900',
              'style': 1,
            },
            {
              'audio_id': '11777',
              'audio_name': '给孩子讲科学家',
              'audio_intro': '大科学家的趣味小故事',
              'audio_icon': 'b/7/e8vwq7d6.jpg',
              'good_price': '2700',
              'style': 1,
            },
            {
              'audio_id': '11934',
              'audio_name': '科学家故事100个',
              'audio_intro': '小学新课标推荐必读书目',
              'audio_icon': 'b/4/zjreency.jpg',
              'good_price': '4990',
              'style': 1,
            } 
          ]
        },
        {
          title: '家长课  和孩子一起成长',
          topicId: '1212',
          list: [
            {
              'audio_id': '12164',
              'audio_name': '教孩子学会自主阅读',
              'audio_intro': '解决幼升小阅读问题',
              'audio_icon': 'b/4/9xzwi9ht.jpg',
              'good_price': '6900',
              'style': 1,
            },
            {
              'audio_id': '11656',
              'audio_name': '梦幻闯关记-阶梯识字课',
              'audio_intro': '游戏中认识汉字',
              'audio_icon': 'b/6/rujsvhj2.jpg',
              'good_price': '6800',
              'style': 1,
            },
            {
              'audio_id': '12355',
              'audio_name': '让孩子的财商更smart',
              'audio_intro': '教孩子学会花钱',
              'audio_icon': 'b/1/l034tjc6.jpg',
              'good_price': '2700',
              'style': 1,
            },
            {
              'audio_id': '12358',
              'audio_name': '语言艺术小课堂',
              'audio_intro': '让孩子拥有好口才',
              'audio_icon': '/b/8/4lau1rxm.jpg',
              'good_price': '2990',
              'style': 1,
            }
          ]
        },
        {
          title: '低龄宝宝专属 安心哄睡',
          topicId: '1004',
          list: [
            {
              'audio_id': '11995',
              'audio_name': '暖房子经典绘本系列',
              'audio_intro': '英国经典绘本|性格养成',
              'audio_icon': 'b/5/cl0s890.jpg',
              'good_price': '2990',
              'style': 1,
            },
            {
              'audio_id': '10252',
              'audio_name': '小鸡彩虹原创儿歌',
              'audio_intro': '和七彩小鸡唱儿歌',
              'audio_icon': 'b/2/bq0lfx8r.jpg',
              'good_price': '2288',
              'style': 1,
            },
            {
              'audio_id': '10234',
              'audio_name': '安徒生童话',
              'audio_intro': '经典广播剧版',
              'audio_icon': 'b/4/49s4zn5z.jpg',
              'good_price': '2000',
              'style': 1,
            },
            {
              'audio_id': '12479',
              'audio_name': '浩然读古诗',
              'audio_intro': '诗词磨耳朵，宝贝睡得香',
              'audio_icon': 'b/9/u9hwxgdx.jpg',
              'good_price': '4900',
              'style': 1,
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'userId',
      'mobile',
      'nickname',
      'avatarUrl',
      'isVip',
      'vipCount',
      'isSub'
    ]),
  },
  watch: {
    vipCount: {
      immediate: true,
      handler: function () {
        let time = new Date().getTime() + this.vipCount * 24 * 60 * 60 * 1000
        this.vipExpireDate = vipExpireFormatter(time)
        if (this.vipText === '') this.vipTextDp = `会员${this.vipExpireDate}到期`
      }
    },
    isVip: {
      immediate: true,
      handler: function () {
        if (this.isVip) {
          this.tipText = this.isSub ? '您是连续订阅会员' : `会员 ${this.vipExpireDate} 到期`
          this.cardBtnText = '立即续费'
          this.buyBtnText = '续费会员'
        } else {
          // 未登录或可以享受9元开通
          if (this.$store.getters.ilistenCaller === '2003') {
            this.tipText = '9元开通会员，7000部VIP故事免费听'
            this.cardBtnText = '立即开通'
            this.buyBtnText = '9元开通会员'
          } else {
            this.tipText = '1元开通会员，7000部VIP故事免费听'
            this.cardBtnText = '立即开通'
            this.buyBtnText = '1元开通会员'
          }
        }
      }
    },
    isSub: {
      immediate: false,
      handler: function () {
        if (this.isVip) {
          this.tipText = this.isSub ? '您是连续订阅会员' : `会员 ${this.vipExpireDate} 到期`
          this.cardBtnText = '立即续费'
          this.buyBtnText = '续费会员'
        } else {
          // 未登录或可以享受9元开通
          if (this.$store.getters.ilistenCaller === '2003') {
            this.tipText = '9元开通会员，7000部VIP故事免费听'
            this.cardBtnText = '立即开通'
            this.buyBtnText = '9元开通会员'
          } else {
            this.tipText = '1元开通会员，7000部VIP故事免费听'
            this.cardBtnText = '立即开通'
            this.buyBtnText = '1元开通会员'
          }
        }
      }
    }
  },
  created () {
    this.filterLayout()
  },
  mounted () {
    $(document).scroll(() => {
      const scrollTop = $(document).scrollTop()
      if (scrollTop > 100) {
        this.showBuyBtn = true
      } else {
        this.showBuyBtn = false
      }
    })
  },
  methods: {
    goLogin() {
      login(window.location.href)
    },
    goMoreRights() {
      this.$router.push({ path: 'viprights' })
    },
    goSubPage () {
      let subOnUrl = encodeURIComponent(`${config.urlPrefix}ilisten.idaddy.cn/vip/subscribeOn`)
      window.location.href = `ilisten:///webopen?pos=in&url=${subOnUrl}&login=1&fullscreen=1`
    },
    goBuyVip() {
      let buyVipUrl = encodeURIComponent(`${config.urlPrefix}ilisten.idaddy.cn/vip/vipPage`)
      window.location.href = `ilisten:///webopen?pos=in&url=${buyVipUrl}&login=1&fullscreen=0`
    },
    goUserHelp() {
      this.$router.push({ path: 'helppage', query: { title: '会员问题', id: 'Q1' } })
    },
    goAudioDetail(audioId) {
      window.location.href = `ilisten:///audio/info?id=${audioId}`
    },
    goTopic (topicId) {
      window.location.href = `ilisten:///topic/info?id=${topicId}&title=` // title不可少(不然安卓打不开)
    },
    filterLayout() {
      let layouts = this.layouts
      layouts.map(layout => {
        let list = layout.list
        list.map(item => {
          item.good_price && (item.good_price = (~~(item.good_price / 100)).toFixed(2))
          if (item.position === 'local') {
            item.audio_icon = require('./img/' + item.audio_icon)
          } else {
            if (item.style == 1) {
              item.audio_icon = `${config.imgUrl}/${item.audio_icon}?imageView2/2/w/250/h/250/q/100`
            } else {
              item.audio_icon = `${config.imgUrl}/${item.audio_icon}`
            }
          }
        })
        return list
      })
      this.layouts = layouts
    }
  },
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";
@import url('./css/swiper.css');

.vip {
  padding-bottom: 1.2rem;
  background: #f2f2f2;
}

.wrap {
  padding-top: .56rem;
  .title {
    margin-bottom: .34rem;
    padding: 0 .5rem;
    font-size: .4rem;
    color: #6c6c73;
    text-align: left;
  }
}

.header {
  background: #fff;
  .wrapper {
    height: 2.6rem;
    padding: 0 .36rem;
    border-radius: ~"100% 100% 100% 100% / 0% 0% 10% 10%";
    background: #f9dd61;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
  }
  .info {
    display: flex;
    padding: .3rem 0;
    .avatar-box {
      position: relative;
      width: 1.12rem;
      height: 1.12rem;
      min-width: 1.12rem;
      .avatar {
        width: 100%;
        height: 100%;
        border: 1px solid #fff;
        border-radius: 50%;
      }
      .avatar-icon {
        position: absolute;
        display: block;
        right: -.12rem;
        bottom: -.08rem;
        width: .4rem;
        height: .4rem;
        border-radius: 50%;
      }
    }
    .detail {
      margin-left: .28rem;
      padding-top: .12rem;
      .user {
        .nickname {
          display: block;
          .ellipsis(3.6rem);
          font-size: .39rem;
          color: #604038;
          font-weight: bold;
        }
        .uid {
          display: block;
          margin-top: .06rem;
          font-size: .25rem;
          color: #604038;
        }
      }
    }
  }
  .card {
    height: .9rem;
    padding: .2rem;
    display: flex;
    align-items: center;
    border-top-left-radius: .24rem;
    border-top-right-radius: .24rem;
    background: #604038;
    .card-icon {
      display: block;
      width: .4rem;
      height: .4rem;
    }
    .tip {
      flex: 1;
      margin-left: .18rem;
      font-size: .24rem;
      color: #fedc42;
      font-weight: bold;
      &-sub {
        margin-left: .2rem;
        padding: .025rem .1rem;
        position: relative;
        border: 1px solid #fedc42;
        border-radius: 10px;
        font-size: .18rem;
        // &::before {
        //   content: '';
        //   width: .2rem;
        //   height: .32rem;
        //   position: absolute;
        //   right: -.25rem;
        //   background: url('~@/assets/vip/icon-in.png') no-repeat;
        //   background-size: 100% 100%;
        // }
        // &::after {
        //   content: '';
        //   height: 60%;
        //   width: .02rem;
        //   background: #fedc42;
        //   position: absolute;
        //   left: -.11rem;
        //   top: 50%;
        //   transform: translateY(-50%);
        // }
      }
    }
    .btn-buy {
      display: flex;
      font-size: .24rem;
      color: #fedc42;
      font-weight: bold;
      .btn-buy-icon {
        display: block;
        margin-left: .08rem;
        width: .2rem;
        height: .32rem;
      }
    }
  }
}

.rights {
  // padding-top: 0;
  background: #fff;
  .list {
    height: 1.6rem;
    box-sizing: initial;
    .item {
      width: 1.6rem;
      height: 1.6rem;
      min-width: 1.6rem;
      &:first-child {
        margin-left: .2rem;
      }
      .pic {
        width: 100%;
        height: 100%;
      }
    }
    .item-white {
      display: block;
      width: .3rem;
      height: 1px;
    }
  }
}

.layouts {
  background: #fff;
  .layout {
    padding: 0 .5rem;
    padding-bottom: .25rem;
    &-title {
      margin-bottom: .32rem;
      font-size: .4rem;
      color: #6c6c73;
      position: relative;
    }
    &-more {
      position: absolute;
      top: 50%;
      right: .22rem;
      transform: translateY(-50%);
      font-size: .28rem;
      color: #a0a0a6;
      &::after {
        content: '';
        width: .16rem;
        height: .32rem;
        background: url('~@/assets/global/arrow_right.png') no-repeat;
        background-size: cover;
        position: absolute;
        right: -.22rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .list {
      position: relative;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        position: relative;
        margin-bottom: .32rem;
        .cover-box {
          position: relative;
          margin-bottom: .16rem;
          overflow: hidden;
          .cover {
            width: 100%;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            background-color: rgba(0,0,0,0.1);
            border-radius: .12rem;
          }
          .cover-tag {
            position: absolute;
            left: 0;
            top: 0;
            width: .84rem;
            height: .42rem;
          }
        }
        .info {
          .name {
            .ellipsis(100%);
            font-size: .34rem;
            color: #6c6c73;
          }
          .desc {
            .ellipsis(100%);
            margin-top: .06rem;
            font-size: .28rem;
            color: #c4c4c6;
          }
          .vip-free-tag {
            display: inline-block;
            width: 1.32rem;
            height: .42rem;
            line-height: .42rem;
            text-align: center;
            background: #ffead2;
            font-size: .28rem;
            color: #faac00;
            border-radius: .03rem;
          }
          .price-tag {
            font-size: .28rem;
            color: #6c6c73;
            margin-right: .08rem;
          }
        }
      }
      .style1 {
        width: 48%;
        .cover-box {
          width: 100%;
        }
        .info {
          .name {
            font-size: .32rem;
          }
          .desc {
            margin-bottom: .12rem;
          }
          .tags {
            .vip-free-tag {
              // margin-left: .08rem;
            }
          }
        }
      }
      .style2 {
        width: 100%;
        .cover-box {
          width: 100%;
        }
        .info {
          margin-top: .16rem;
          .name {
            display: flex;
            justify-content: space-between;
          }
          .desc {
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
}

.more-rights {
  padding-bottom: .5rem;
  background: #fff;
  .title {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .all-rights {
      display: inline-flex;
      align-items: center;
      font-size: .28rem;
      color: #a0a0a6;
      .icon-more {
        margin-left: .06rem;
        width: .16rem;
        height: .32rem;
        transform: translateY(.02rem);
      }
    }
  }
  .list {
    padding: 0 .5rem;
    .item {
      display: flex;
      margin-bottom: .5rem;
      .pic {
        width: 2.16rem;
        height: 2.16rem;
      }
      .info {
        flex: 1;
        margin-left: .24rem;
        .item-title {
          margin-bottom: .2rem;
          font-size: .36rem;
          color: #665a57;
        }
        .desc {
          line-height: 1.5;
          color: #a0a0a6;
          font-size: .24rem;
          text-align: justify;
        }
      }
    }
  }
}

.vip-help {
  margin: .32rem 0;
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .36rem;
    height: .96rem;
    background: #fff;
    color: #6c6c73;
    font-size: .3rem;
    .help-more-icon {
      display: block;
      width: .16rem;
      height: .32rem;
    }
  }
}

.buyvip {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  padding: .2rem .36rem;
  box-shadow: 0 -6px 12px rgba(44,42,64,.08);
  background: #fff;
  &-title {
    font-size: .34rem;
    font-weight: 600;
    color: #FCAC00;
  }
  &-desc {
    margin-top: 2px;
    opacity: 0.8;
    font-size: .26rem;
    color: #A0A0A6;
  }
  .btn-buyvip {
    padding: .22rem 0;
    margin-left: 1.3rem;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    border-radius: 200px;
    background-image: linear-gradient(134deg, #f8dd61, #feb800);
    color: #604038;
    font-size: .28rem;
    font-weight: bold;
    .buyvip-icon {
      display: block;
      margin-right: .18rem;
      width: .4rem;
      height: .4rem;
      transform: translateY(.04rem);
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
